import * as Diff from 'deep-diff';
function getAllSubArraysFromStart(array) {
    const result = [];
    for (let i = 0; i < array.length; i++) {
        result.push(array.slice(0, i + 1));
    }
    return result;
}
function getFieldPathString(fieldPath) {
    return fieldPath
        .map(fieldPathItem => 
    // Если часть пути числовая, значит это индекс массива.
    // Заменяем его на [number], чтобы можно было включить в фильтр
    typeof fieldPathItem === 'number' ? '[number]' : fieldPathItem)
        .join('.');
}
function checkIsLhsAndRhsEmpty(diff) {
    return (!('lhs' in diff) || diff.lhs == null) && (!('rhs' in diff) || diff.rhs == null);
}
function checkIsLhsAndRhsEmptyRecursively(diff) {
    if (diff.item.kind === 'A') {
        return checkIsLhsAndRhsEmptyRecursively(diff.item);
    }
    return checkIsLhsAndRhsEmpty(diff.item);
}
/**
 * Функция для глубокого поиска отличающихся параметров в объекте.
 *
 * @param left Левый объект сравнения
 * @param right Правый объект сравнения
 * @param options Дополнительные параметры для функции
 * @typeParam T Тип объекта
 * @returns Массив с различиями, если они имеются
 * @example
 * ```ts
 * const obj1 = {
 *   name: 'John',
 *   age: 30,
 *   address: {
 *     city: 'Moscow',
 *     street: 'Lenina'
 *   }
 * };
 *
 * const obj2 = {
 *   name: 'John',
 *   age: 31,
 *   address: {
 *     city: 'Moscow',
 *     street: 'Pushkina'
 *   }
 * };
 *
 * const differences = deepDiff(obj1, obj2);
 * console.log(differences);
 * // [
 * //   { kind: 'E', path: ['age'], lhs: 30, rhs: 31 },
 * //   { kind: 'E', path: ['address', 'street'], lhs: 'Lenina', rhs: 'Pushkina' }
 * // ]
 * ```
 * @example
 * ```ts
 * // Использование ignoreFields для игнорирования определенных полей
 * const obj1 = { name: 'John', age: 30, internal: 'secret' };
 * const obj2 = { name: 'John', age: 31, internal: 'secret' };
 *
 * const differences = deepDiff(obj1, obj2, {
 *   ignoreFields: ['internal']
 * });
 * console.log(differences);
 * // [{ kind: 'E', path: ['age'], lhs: 30, rhs: 31 }]
 * ```
 * @example
 * ```ts
 * // Использование normalize для нормализации значений
 * const obj1 = { date: new Date('2023-01-01') };
 * const obj2 = { date: new Date('2023-01-01') };
 *
 * const differences = deepDiff(obj1, obj2, {
 *   normalize: (path, key, lhs, rhs) => {
 *     if (lhs instanceof Date && rhs instanceof Date) {
 *       return [lhs.getTime(), rhs.getTime()];
 *     }
 *   }
 * });
 * console.log(differences); // undefined (даты равны после нормализации)
 * ```
 */
export function deepDiff(left, right, options = {}) {
    const { normalize, ignoreFields } = options;
    const fullDiff = Diff.diff(left, right, { normalize });
    const diff = fullDiff &&
        fullDiff.filter(
        // Игнорировать диффы, у которых:
        diff => !((diff.path &&
            ignoreFields?.length &&
            // - Пути лежат внутри заигноренных папок или являются заигноренными
            getAllSubArraysFromStart(diff.path)
                .map(getFieldPathString)
                .some(fieldPathString => ignoreFields.includes(fieldPathString))) ||
            // - С обеих сторон нет значения или содержит null | undefined, для всех типов diff'а кроме массива
            (diff.kind !== 'A' && checkIsLhsAndRhsEmpty(diff)) ||
            // - В элементе массива с обеих сторон не содержит значения или содержит null | undefined
            (diff.kind === 'A' && checkIsLhsAndRhsEmptyRecursively(diff))));
    return diff;
}
